import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(submitAmplitudeEventSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(eventsSagas);

import { select, takeEvery } from 'redux-saga/effects';
import { GaiaApolloClient } from '../../gaia-data/apolloClient';
import { userSelectors } from '../../user/redux/user-reducer';
import { amplitudeHelper, initAmplitudeUser, SEND_AMPLITUDE_EVENT } from '../amplitudeHelper';
import { getConfig } from '../../gaia-data/init';
import { AnalyticEventMutation } from '../apollo/events-graphql';
import { getPlatform } from '../device-utils';

// eslint-disable-next-line require-yield
function submitAmplitudeEventSaga(action) {
  var _extends2;

  var eventName, inProps, propNames, analyticEvent, userId;
  return _regeneratorRuntime.wrap(function submitAmplitudeEventSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          eventName = action.payload.eventName;
          inProps = action.payload.eventProperties;
          propNames = amplitudeHelper.analyticEventPropNames;
          analyticEvent = {
            eventProps: _extends((_extends2 = {}, _extends2[propNames.appName] = getConfig().appName || 'n/a', _extends2[propNames.appVersion] = getConfig().appVersion || 'n/a', _extends2[propNames.platform] = getPlatform(), _extends2[propNames.sreVersion] = getConfig().sreVersion || 'n/a', _extends2[propNames.screenWidth] = window.innerWidth, _extends2[propNames.screenHeight] = window.innerHeight, _extends2[propNames.userAgent] = navigator.userAgent, _extends2), inProps)
          };

          // fill in eventName if it is standard else put in otherEventType

          if (amplitudeHelper.analyticEventNames.hasOwnProperty(eventName)) {
            analyticEvent[propNames.eventType] = eventName;
          } else {
            analyticEvent[propNames.eventType] = amplitudeHelper.analyticEventNames.OTHER_EVENT;
            analyticEvent[propNames.otherEventType] = eventName;
          }
          _context.next = 7;
          return select(userSelectors.getUserId);

        case 7:
          userId = _context.sent;

          if (!userId) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return initAmplitudeUser(userId);

        case 11:

          GaiaApolloClient.mutate({
            mutation: AnalyticEventMutation,
            variables: {
              analyticEvent: analyticEvent
            }
          });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

export function eventsSagas() {
  return _regeneratorRuntime.wrap(function eventsSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(SEND_AMPLITUDE_EVENT, submitAmplitudeEventSaga);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}